export default __webpack_public_path__ + "static/media/terms-and-condition.ade93def.svg";